var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"rotate":360,"size":70,"width":15,"value":_vm.total_progress,"color":"teal"}},[_vm._v("\n    "+_vm._s(_vm.total_progress)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }